import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import * as thunks from './thunks';

const slice = createSlice({
    name: 'plugins',
    initialState: {
        isLoading: false,
        status: {
            updating: false,
            creating: false,
            loading: false,
            deleting: false
        },
        plugins: [],
        plugin: {
            id: '',
            name: '',
            slug: '',
            description: '',
            type: 'plugin',
            features: [],
            status: 'edit',
            billing_plan_display_type: 'by_interval',
            thumbnail_id: null,
            thumbnail: null,
            license: null,
        },
        downloads: [],
        errors: []
    },
    reducers: {
        setPlugins: (state, action) => {
            state.plugins = action.payload;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setPlugin: (state, action) => {
            state.plugin = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(thunks.fetchPlugins.pending, state => {
                state.status.loading = true;
            })
            .addCase(thunks.fetchPlugins.fulfilled, (state, action) => {
                state.plugins = action.payload;
                state.status.loading = false;
            })
            .addCase(thunks.fetchPlugins.rejected, (state, action) => {
                state.errors = [...state.errors, action.error];
                state.status.loading = false;
            })
            .addCase(thunks.fetchPlugin.pending, state => {
                state.status.loading = true;
            })
            .addCase(thunks.fetchPlugin.fulfilled, (state, action) => {
                state.plugin = action.payload;
                state.status.loading = false;
            })
            .addCase(thunks.fetchPlugin.rejected, (state, action) => {
                state.errors = [...state.errors, action.error];
                state.status.loading = false;
            })
            .addCase(thunks.fetchPluginLicense.pending, state => {
                state.status.loading = true;
            })
            .addCase(thunks.fetchPluginLicense.fulfilled, (state, action) => {
                state.plugin.license = action.payload;
                state.status.loading = false;
            })
            .addCase(thunks.fetchPluginLicense.rejected, (state, action) => {
                state.errors = [...state.errors, action.error];
                state.status.loading = false;
            })
            .addCase(thunks.fetchDownloads.pending, state => {
                state.status.loading = true;
            })
            .addCase(thunks.fetchDownloads.fulfilled, (state, action) => {
                state.downloads = action.payload;
                state.status.loading = false;
            })
            .addCase(thunks.fetchDownloads.rejected, (state, action) => {
                state.errors = [...state.errors, action.error];
                state.status.loading = false;
            })
            .addCase(thunks.deletePluginDomain.pending, state => {
                state.status.deleting = true;
            })
            .addCase(thunks.deletePluginDomain.fulfilled, (state, action) => {
                state.plugin.license.domains = action.payload;
                state.status.deleting = false;
            })
            .addCase(thunks.deletePluginDomain.rejected, (state, action) => {
                state.errors = [action.error];
                state.status.deleting = false;
            })
    }
});

export default slice.reducer;

export const {
    setPlugins,
    setPlugin,
    setLoading,
} = slice.actions;

export const {
    fetchPlugins,
    fetchPlugin,
    fetchDownloads,
    fetchPluginLicense,
    deletePluginDomain,
} = thunks;
